import { Injectable } from "@angular/core";

import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse, SaleOrder, Trips } from "@tendercuts/models";

import { HttpClient } from "@angular/common/http";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";

@Injectable()
export class AddCashToTripService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get endpoint(): string {
    return this.endpointService.addCashToTrip;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  getParams(
    tripId: number,
    cash: number,
  ): {
    trip: number;
    amount: number;
  } {
    return {
      trip: tripId,
      amount: cash,
    };
  }
}
